<ng-container *ngFor="let app of applications">
  <app-doctors-station-register-send
    *ngIf="isStation && app.clientId === clientId"
    [clientId]="clientId"
  ></app-doctors-station-register-send>
  <app-dr-dish-register-send
    *ngIf="app.type === 'dr-dish' && app.clientId === clientId"
    [clientId]="clientId"
  ></app-dr-dish-register-send>
  <app-suguyaku-register-send
    *ngIf="app.type === 'suguyaku' && app.clientId === clientId"
    [clientId]="clientId"
  ></app-suguyaku-register-send>
  <app-doctors-next-register-send
    *ngIf="app.type === 'dnext' && app.clientId === clientId"
    [clientId]="clientId"
  ></app-doctors-next-register-send>
  <app-collabo-portal-register-send
    *ngIf="app.type === 'cportal' && app.clientId === clientId"
    [clientId]="clientId"
  ></app-collabo-portal-register-send>
  <app-sgzp-app2register-send
    *ngIf="app.type === 'cportal-sgzp-app2' && app.clientId === clientId"
    [clientId]="clientId"
  ></app-sgzp-app2register-send>
  <app-sas-station-register-send
    *ngIf="app.type === 'sas-station' && app.clientId === clientId"
    [clientId]="clientId"
  ></app-sas-station-register-send>
</ng-container>
<app-dynamic-component-host #dynamicComponentHost></app-dynamic-component-host>
